// The site's own pages — home, About, Privacy, the words over each list. All of
// them in one request, so moving between them never waits on the next.
import type { SitePageId, SitePageInput, SitePageView } from "@bibleunleashed/shared";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, put } from "./api";

const KEY = ["pages"];

export function usePages() {
  return useQuery({ queryKey: KEY, queryFn: () => api<SitePageView[]>("/api/pages"), staleTime: 5 * 60_000 });
}

export function usePage(id: SitePageId): SitePageView | undefined {
  return usePages().data?.find((p) => p.id === id);
}

export function useSavePage(id: SitePageId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: SitePageInput) => put<SitePageView>(`/api/pages/${id}`, body),
    onSuccess: (saved) => qc.setQueryData<SitePageView[]>(KEY, (all) => all?.map((p) => (p.id === id ? saved : p))),
  });
}
